import CampaignBanner from 'Components/campaigns/create-edit/CampaignBanner';
import { PRIVILEGE } from 'constants/privilege';
import withAccessControl from 'hoc/withAccessControl';
import { usePrivileges } from 'hooks/useAuth';
import CampaignCreationLayout from 'Layouts/CampaignCreationLayout';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';
import { updateCampaignCreatives } from 'services/api/campaign';
import { fetchCampaignCreatives } from 'slices/campaigns/creatives/thunk';
import { markCampaignDataExpired } from 'slices/campaigns/reducer';
import { sendCampaignForApprovalRequest } from 'slices/campaigns/thunk';
import { AppDispatch, RootState } from 'store';
import { getErrorMessage } from 'utils/helpers';


const CampaignCreatives = () => {

    const { campaignId } = useParams();
    const privileges = usePrivileges();

    const selectedAgency = useSelector((state: RootState) => state.auth.selectedAgency);

    const campaignCreatives = useSelector((state: RootState) => state.campaignCreatives.campaigns[campaignId!])

    const campaign = campaignCreatives?.campaign ?? null;
    const gallery = campaignCreatives?.gallery ?? [];

    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    const [saving, setSaving] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const [campaignHeroImage, setCampaignHeroImage] = useState<File | null>(null);

    useEffect(() => {
        if (campaignId) {
            dispatch(fetchCampaignCreatives({ campaignId }));
        }
    }, [dispatch, campaignId])


    const submitCreatives = async () => {
        if (!campaignId) return;
        try {
            if (!privileges.includes(PRIVILEGE.CAMPAIGN.CAMPAIGN.EDIT))
                throw new Error("You are not authorized to perform this action!");

            setSaving(true);
            const formData = new FormData();
            if (campaignHeroImage) {
                formData.append('hero_img', campaignHeroImage);
            }
            const response = await updateCampaignCreatives(selectedAgency?.uuid!, campaignId, formData);
            dispatch(markCampaignDataExpired({ campaignId }));
            if (response) {
                navigate('/campaign/' + campaignId);
            }
        } catch (error) {
            console.log(error);
            toast.error(getErrorMessage(error, 'Failed to submit creatives'));
        } finally {
            setSaving(false);
        }
    }

    const submitAndRequestApproval = async () => {
        if (!campaignId) return;
        try {
            if (!privileges.includes(PRIVILEGE.CAMPAIGN.CAMPAIGN.EDIT))
                throw new Error("You are not authorized to perform this action!");

            setSubmitting(true);
            const formData = new FormData();
            if (campaignHeroImage) {
                formData.append('hero_img', campaignHeroImage);
            }
            await updateCampaignCreatives(selectedAgency?.uuid!, campaignId, formData);
            await dispatch(sendCampaignForApprovalRequest({ campaignId }))
            dispatch(markCampaignDataExpired({ campaignId }));
            navigate('/campaign?status=pending');
        } catch (error) {
            console.log(error);
            toast.error(getErrorMessage(error, 'Failed to submit creatives'));
        } finally {
            setSubmitting(false);
        }


    }

    return (
        <CampaignCreationLayout
            activeStep='banner'
            actionRow={
                <div className="d-flex justify-content-between mb-4">
                    <div></div>
                    <button type='button' onClick={submitCreatives} disabled={saving || !privileges.includes(PRIVILEGE.CAMPAIGN.CAMPAIGN.EDIT)} className="theme-btn theme-btn-lg btn-gradient form-continue-btn d-flex justify-content-between align-items-center">
                        <React.Fragment>
                            {
                                'Save'
                            }
                            {
                                saving ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : <i className='bx fs-4 bx-right-arrow-alt' ></i>
                            }
                        </React.Fragment>
                    </button>
                </div>
            }
        >
            <CampaignBanner
                campaignId={campaignId!}
                campaignHeroImage={campaign?.hero_img_url ?? null}
                gallery={gallery}
                hideGallery={true}
                onHeroImageChange={(newHeroImage) => setCampaignHeroImage(newHeroImage)}
            />
        </CampaignCreationLayout>
    )
}

export default withAccessControl(CampaignCreatives, PRIVILEGE.CAMPAIGN.CAMPAIGN.EDIT)